var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1639.7 1599.1",
    style: {
      enableBackground: "new 0 0 1639.7 1599.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:40;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19.9,
    className: "st0",
    width: 1600,
    height: 1560
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1500.3,126.5H139.7c-6.8,0-12.2,5.5-12.2,12.2v1322.5c0,6.7,5.4,12.2,12.2,12.2h1360.6 c6.7,0,12.2-5.4,12.2-12.2V138.7C1512.5,132,1507.1,126.5,1500.3,126.5z M841,684.7c-21.3,85-81.2,132.2-163.7,149.3 c-40.1,8.3-82.4,6.5-123.7,9.3h-0.1c-6.4,0.4-11.4,5.8-11.4,12.2c0,72.8,0,144.1,0.1,215.4c0,21.6,0,21.6-21.5,21.6 c-25.2,0.1-50.4-0.3-75.5,0.2c-11.5,0.2-15-4.2-15-15.5c0.3-219.4,0.3-438.9,0.1-658.3c0-10,1.6-17.8,13.4-18.1 c78.6-1.8,157.5-10.3,235.7,3.4c103.7,18.1,164.1,86.1,169.6,191.2C850.5,625,848.2,656,841,684.7z M1223.3,982 c-11.9,61.4-52.4,97.1-110.9,112.5c-62.2,16.3-123.5,10.6-183.6-11.7c-13.1-4.8-18.5-12.5-18-26.9c0.8-22.7,0.6-45.4,0.4-70.3 c0-9.3,9.9-15.2,18.1-10.8c0.9,0.5,1.9,1,2.7,1.3c43.1,22.8,88.6,34.3,137.5,27c21.1-3.2,38.9-12,44.9-35 c5.9-22.8-4-40.3-21.6-52.6c-20.1-14.1-42-25.5-62.7-38.6c-24.9-15.7-52-29.2-73.5-48.7c-75.8-68.6-56-193.1,37-235.7 c64.6-29.5,131.1-23.7,197.1-4c5.8,1.7,12.8,11.1,13.1,17.3c1.5,26.2,0.6,52.5,0.7,78.8c0.1,12.6-5.2,13.9-15.3,8.3 c-30.8-17.1-64.3-23.9-99.2-25c-6.5-0.2-13.1,0-19.6,0.8c-28.4,3.7-46.4,16.6-50.8,37c-5.4,25.2,9.7,40.4,28.3,52.4 c17.9,11.5,37,21.2,55.3,32c20.7,12.2,42,23.6,61.5,37.5C1218.2,865.8,1235.5,919.1,1223.3,982z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.3,509.1c0-7,5.8-12.6,12.8-12.2c32.3,1.6,64.3,1.5,95.2,7.2c50.1,9.3,79.4,45.5,83.4,96.4 c1.3,16.2,1,33-1.7,49c-9,53.6-44.1,84.7-106.4,92c-23.2,2.7-46.8,1.1-71.4,0.7c-6.6-0.1-12-5.6-12-12.2V509.1H544.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsDark);
export default __webpack_public_path__ + "static/media/ps_dark.1ebbcbce5b11827feeefa4e02af0ff07.svg";
export { ForwardRef as ReactComponent };